import Api from './Api'

export default {
  getSignedURL(file) {
    return Api().get('/media/upload', {
      params: {
        filePath: file.name,
        contentType: file.type
      }
    });
  },
  getDefaultMedia() {
    return Api().get('/media/default')
  },
  getMedia(id) {
    const params = {
      params: {}
    }
    if (id) params.params.id = id
    return Api().get('/media', params)
  },
  getCriteria() {
    return Api().get('/media/criteria')
  },
  uploadDefaultMedia(data) {
    return Api().put('/media/default', data)
  },
  saveMedia(data) {
    if (data.hasOwnProperty('id')) {
      return Api().put('/media', data)
    }
    return Api().post('/media', data)
  },
  deleteMedia(id) {
    return Api().delete('/media', {
      params: {
        id
      }
    })
  },
  getStats() {
    return Api().get('/media/stats')
  }
}